<template>
  <div class="page " style="min-height: 100vh;">
    <div class="container  inner-page">
      <div class="app-header">
        <router-link :to="{ name: 'Home' }"><img class="app-logo" src="../assets/logo2.png"/></router-link>

        <router-link :to="{ name: 'Themes' }" class="back" v-if="displayUploadButton"><img src="../assets/back.svg"/></router-link>
      </div>

      <div style=" " v-if="layout">
        <div v-show="displayUploadButton">
          <div v-if="$t('themes.text')" style=" margin-top: 2rem; margin-bottom: 1rem; text-align:center" v-html="$t('themes.text')"></div>
          <LiveView
            ref="liveView"
            :layout="layout"
            v-on:accessDenied="displayHelpMessage"
            v-on:fileUpload="doFileUpload"
            v-on:imgOK="onLiveViewImageOK"
          >
          </LiveView>
        </div>

        <div style=" " v-if="displayText">
          <h1 class="title" style="" v-if="formTitle">{{ formTitle }}</h1>
          <h2 class="subtitle" style="font-size:1rem" v-if="formSubTitle">{{ formSubTitle }}</h2>
          <div class="form-panel">
            <div class="field">
              <div class="control">
                <input class="input" type="text" maxlength="100" :placeholder="$t('form.textLabel')" v-model="text" />
              </div>
            </div>
            <div class="field ">
              <div class="control">
                <a class="btn" style="min-width: 100%;" @click="onSubmit">{{ $t('form.btnText') }}</a>
              </div>
            </div>
          </div>
        </div>

        <div style=" " v-if="displayQrCode">
          <h1 class="title" style="" v-if="qrTitle">{{ qrTitle }}</h1>
          <h2 class="subtitle" style="font-size:1rem" v-if="qrSubTitle">{{ qrSubTitle }}</h2>
          <div id="qrcode">
            <img :src="this.displayQrCode" />
          </div>
        </div>

        <div style=" margin-bottom:1.5rem" class="process-message" v-if="displayProcessMessage">{{ message }}</div>

        <div v-if="uploading">
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated" :style="{ width: uploadPercent + '%' }"></div>
          </div>
        </div>

        <div v-if="processing">
          <svg width="70" height="70" viewBox="0 0 105 105" xmlns="http://www.w3.org/2000/svg" id="processAnim">
            <circle cx="12.5" cy="12.5" r="12.5">
              <animate attributeName="fill-opacity" begin="0s" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="12.5" cy="52.5" r="12.5" fill-opacity=".5">
              <animate attributeName="fill-opacity" begin="100ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="52.5" cy="12.5" r="12.5">
              <animate attributeName="fill-opacity" begin="300ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="52.5" cy="52.5" r="12.5">
              <animate attributeName="fill-opacity" begin="600ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="92.5" cy="12.5" r="12.5">
              <animate attributeName="fill-opacity" begin="800ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="92.5" cy="52.5" r="12.5">
              <animate attributeName="fill-opacity" begin="400ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="12.5" cy="92.5" r="12.5">
              <animate attributeName="fill-opacity" begin="700ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="52.5" cy="92.5" r="12.5">
              <animate attributeName="fill-opacity" begin="500ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
            <circle cx="92.5" cy="92.5" r="12.5">
              <animate attributeName="fill-opacity" begin="200ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite" />
            </circle>
          </svg>
        </div>

        <div v-if="picUrl">
          <div>
            <img
              :src="picUrl"
              class="result-pic"
              style=" -webkit-user-select:none; -webkit-touch-callout:none; pointer-events: none;"
              v-bind:class="{ noBorderRadius: layout.borderRadius == false }"
            />
          </div>

          <div style="margin-top:0.5em; margin-bottom: 1.2em;">
            {{ $t('theme.notGood') }} &nbsp;&nbsp;<a class="try-again" @click="tryAgain">{{ $t('theme.tryAgain') }}</a>
          </div>

          <div class="btn btn-full theme-btn" style="" @click="clickShowQR">
            <span>{{ $t('theme.continue') }}</span>
          </div>
        </div>
      </div>

      <input type="file" class="pic-input" ref="picInput" accept="image/*" />

      <Footer v-if="!displayProcessMessage" ref="footer" :displayDemoText="displayFooterDemoText"></Footer>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios';
import QRCode from 'qrcode';
import loadImage from 'blueimp-load-image';
// import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';

import { getLayout, incrementCount } from '../store';
import LiveView from '../components/LiveView.vue';

const downloadIcon = require('../assets/download-icon.svg');
const landscapeIcon = require('../assets/landscape-icon.jpg');
const portraitIcon = require('../assets/portrait-icon.jpg');

export default {
  name: 'Theme',

  components: {
    /*
    Swiper,
    SwiperSlide,
    */ //
    LiveView,
  },
  directives: {
    // swiper: directive,
  },

  data() {
    return {
      uploadPercent: 0,
      displayUploadButton: true,
      displayText: false,
      displayQrCode: false,

      uploading: false,
      processing: false,
      picUrl: null,
      message: '',
      shareUrl: '',
      layoutId: null,
      text: '',

      swiperOptions: {
        effect: 'fade',
        loop: true,
        slidesPerView: 1,
        speed: 800,
        autoplay: {
          delay: 1500,
          disableOnInteraction: false,
        },
      },
    };
  },

  computed: {
    processFillColor() {
      return this.$i18n.messages.processFillColor;
    },
    layouts() {
      return this.$store.eventConfig;
    },

    previewBaseSrc() {
      if (!this.layout) {
        return null;
      }

      let src = this.layout[`previewBase_${this.$i18n.locale}`];

      if (!src) {
        src = this.layout.previewBase;
      }

      return src;
    },

    layout() {
      if (!this.$store.eventConfig || !this.layoutId) {
        return null;
      }

      return getLayout(this.layoutId);
    },

    displayProcessMessage() {
      return this.uploading || this.processing;
    },

    isUploadEnabled() {
      return true;
    },

    displayFooterDemoText() {
      return this.picUrl == null;
    },

    downloadIconUrl() {
      return downloadIcon;
    },

    formTitle() {
      const v = this.$i18n.t('form.title');

      if (v.length >= 0) {
        return v;
      }
      return null;
    },

    formSubTitle() {
      const v = this.$i18n.t('form.subtitle');

      if (v.length >= 0) {
        return v;
      }
      return null;
    },

    qrTitle() {
      const v = this.$i18n.t('qr.title');

      if (v.length >= 0) {
        return v;
      }
      return null;
    },

    qrSubTitle() {
      const v = this.$i18n.t('qr.subtitle');

      if (v.length >= 0) {
        return v;
      }
      return null;
    },
  },

  methods: {
    async clickShowQR() {
      this.displayQrCode = await QRCode.toDataURL(`zzzz/g/${this.qrCode}`, { width: 256, height: 256 });
      this.picUrl = null;
      this.showQRCode();
    },

    displayHelpMessage() {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      const text = this.$i18n.t(isIOS ? 'cameraHelp.ios' : 'cameraHelp.android');
      this.$swal({
        html: `<div style='text-align:left'>${this.$i18n.t('cameraHelp.text')}<br><br>${text}</div>`,
      });
    },

    async uploadFile(file, captchaToken) {
      const formData = new FormData();
      formData.append('layout', this.layout.id);
      formData.append('pic', file);
      formData.append('text', this.text);

      // 'Sending image...';

      this.processing = false;
      this.picUrl = null;

      const { eventId, shortEventId } = this.$store;

      this.$statEvent('upload_pic');

      const selfInstance = this;

      try {
        const response = await axios.post(
          '/api/media?qrPrint=1',

          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              token: captchaToken,
              'event-id': eventId,
              'short-event-id': shortEventId,
            },
            onUploadProgress(progressEvent) {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              selfInstance.uploadPercent = percentCompleted;

              if (percentCompleted >= 100 && selfInstance.uploading) {
                setTimeout(() => {
                  if (selfInstance.uploading === true) {
                    // check we are uploading

                    selfInstance.message = selfInstance.$i18n.t('theme.processing');
                    selfInstance.uploading = false;
                    selfInstance.processing = true;
                  }
                }, 200);
              }
            },
          },
        );

        this.message = '';
        incrementCount();

        this.picUrl = response.data.url;
        this.qrCode = response.data.qrCode;

        this.$store.mediaId = response.data.id;
        this.$store.mediaUrl = `/api/media/${response.data.id}`; // response.data.url;
        this.$store.downloadUrl = `/api/media/${response.data.id}`; // response.data.url;

        this.$store.shareUrl = response.data.shareUrl;
      } catch (err) {
        const res = err.response;
        console.error('Upload error:', err);
        if (res) {
          console.log('Response data', res.data);
        }

        // this.$statEvent('upload_pic_error');

        this.message = '';
        this.displayUploadButton = true;

        let errorMessage = 'Sorry, something went wrong.';

        if (res.data && res.data.code) {
          const errorCode = res.data.code;

          if (errorCode === 'MODERATION_FAILED') {
            errorMessage = 'Sorry, your photo is inappropriate.';
          }

          if (errorCode === 'DOG_CAT_CHECK') {
            errorMessage = selfInstance.$i18n.t('check.noCatDog');
          }

          if (errorCode === 'DOG_CAT_CHECK_PERSON') {
            errorMessage = selfInstance.$i18n.t('check.noCatDogPerson');
          }
        }

        this.$swal({
          icon: 'error',
          title: null,
          text: errorMessage,
        });
      } finally {
        this.uploading = false;
        this.processing = false;
        this.$refs.picInput.value = '';
      }
    },

    displayContact() {
      this.$refs.footer.displayContact();
    },

    tryAgain() {
      this.$refs.liveView.restartCapture();
      this.picUrl = null;
      this.displayUploadButton = true;
    },

    doFileUpload() {
      // this.$refs.liveView.stop();
      this.$statEvent('pic_upload_retry');
      this.$refs.picInput.click();
    },

    displayProgress() {
      this.displayUploadButton = false;
      this.message = this.$i18n.t('theme.sending');
      this.uploadPercent = 0;
      this.uploading = true;
    },

    onLiveViewImageOK() {
      setTimeout(() => {
        const file = this.$refs.liveView.processImg();
        this.uploadCaptcha(file);
      }, 1);
    },

    uploadCaptcha(file) {
      this.file = file;
      this.displayUploadButton = false;
      this.displayText = true;
    },

    onSubmit() {
      this.displayText = false;
      const { file } = this;
      this.displayProgress();

      const self = this;
      window.grecaptcha.ready(() => {
        // eslint-disable-next-line no-underscore-dangle
        window.grecaptcha.execute(window._captchaId, { action: 'uploadpic' }).then(
          (token) => {
            self.uploadFile(file, token);
          },
          (reason) => {
            console.error('Captcha failure:', reason);

            self.$swal({
              icon: 'error',
              title: 'Oops...',
              text: 'Sorry, something went wrong.\nPlease check your internet connection?',
            });

            this.uploading = false;

            self.$refs.picInput.value = '';
          },
        );
      });
    },

    validateImage(file) {
      loadImage(
        file,
        (img, data) => {
          if (img.type === 'error') {
            console.error('Error loading image file', img);
            this.uploadCaptcha(file);
            return;
          }

          console.log('w:', img.width, 'h:', img.height, data.exif && data.exif.get('Orientation'));

          let { orientationCheck } = this.layout;

          if (!orientationCheck || orientationCheck.trim().length === 0) {
            this.uploadCaptcha(file);
            return;
          }
          orientationCheck = orientationCheck.toUpperCase();
          let porientation = '';

          if (img.height > img.width) {
            porientation = 'P';
          } else if (img.height === img.width) {
            porientation = 'S';
          } else {
            porientation = 'L';
          }

          // orientation ok
          if (orientationCheck.indexOf(porientation) >= 0) {
            this.uploadCaptcha(file);
            return;
          }

          let portraitMode = false;
          if (orientationCheck.indexOf('P') >= 0) {
            portraitMode = true;
          }

          // display error message
          this.$swal({
            text: portraitMode ? this.$i18n.t('validation.portrait') : this.$i18n.t('validation.landscape'),
            imageUrl: portraitMode ? portraitIcon : landscapeIcon,
            imageHeight: portraitMode ? 125 : 75,
          });

          // clear input
          this.$refs.picInput.value = '';
        },
        { meta: true, orientation: true },
      );
    },
  },

  async mounted() {
    //

    this.layoutId = this.$route.params.id;
    this.$store.layoutId = this.layoutId;
    /*
    this.$statPage({
      page_title: `Theme view -  ${this.layoutId}`,
      page_path: `/theme/${this.layoutId}`,
    });
*/
    setTimeout(() => {
      const self = this;

      this.$refs.picInput.onchange = function onChange(e) {
        const { files } = e.target;
        const file = files[0];
        self.validateImage(file);
      };
    }, 50);
  },
};
</script>

<style scoped>
.back {
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -16px;
  display: none;
}

.back img {
  height: 32px;
}

.swiper-container {
  width: 100%;
  height: 100%;
  background: transparent;
}

.result-pic {
  height: auto;
  border-radius: 8px;
  border: 1px solid #525252;
}

.result-pic,
.theme-btn {
  max-width: 300px;
}

.result-pic.noBorderRadius {
  border-radius: 0;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;

  cursor: pointer;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  max-width: 100%;
  max-height: 340px;
  border-radius: 8px;
}

.noBorderRadius .swiper-slide img {
  border-radius: 0;
}

/*
.pic-input {
  height: 999px;
  cursor: pointer;
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 200px;
  z-index: 2;
  opacity: 0;
  filter: alpha(opacity=0);
}*/

.pic-input {
  display: none;
}

.process-message {
  font-size: 1.2em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.try-again {
  text-decoration: underline;
  cursor: pointer;
}

.downloadLink {
  text-decoration: underline;
  color: #fff !important;
}
.sharePanel {
  border-radius: 6px;
  margin: 2em 0;
}

.downloadLink img {
  height: 24px;
  width: auto;
  margin-right: 0.4em;
  display: inline-block;
  vertical-align: top;
}

.downloadLink span {
  line-height: 24px;
}
</style>
